import * as React from 'react';
import { Redirect } from 'react-router-dom';
import Loader from 'react-loader';

import withServices  from '../../../HOCs/withServices';
import Navbar from '../../../components/CustomNav/CustomNav.Component';
import SummaryInfo from '../../../components/DataCentre/SummaryInfo';
import CoursePicker from '../../../components/DataCentre/CoursePicker';
import CourseTracker from '../../../components/DataCentre/CourseTracker';
import PerformanceGraph from '../../../components/DataCentre/PerformanceGraph';
import LessonSelector from '../../../components/DataCentre/LessonSelector';

import { Wrapper, Content, ContentRow, ContentCol } from './DataCentre.styles';
 

interface IProps {
  services?: any;
}

interface IState {
  toLogin: boolean,
  loaded: boolean,
  data: any,
  selectedCourse: string,
  completedLessons: any,
}

class DataCentre extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      toLogin: false,
      loaded: true,
      data: {},
      selectedCourse: '',
      completedLessons: [],
    };

    this.onLogout = this.onLogout.bind(this);
  }

  public async componentDidMount() {
    const { services: { isUserLoggedIn, currentUserID, studentsAPI } } = this.props;

    if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

    const res = await studentsAPI.getCoursesSummary({ studentID: currentUserID });

    if (res.ok) {
      this.setState({ data: res.data });
    } else {
      alert('Error fetching student\'s details!');
    }
  }

  public onLogout() {
    this.setState({ toLogin: true });
  }

  public onSelectCourse = (e) => {
    const { data } = this.state;
    const selectedCourse = e.target.value;
    const completedLessons = data.courses_taken[Number(selectedCourse)].LessonAllocations.filter(lesson => lesson.Completed);

    this.setState({ selectedCourse, completedLessons });
  }

  public render() {
    const { data, toLogin, selectedCourse, completedLessons } = this.state;

    if (toLogin) { return <Redirect to="/login" />; }
    if (Object.keys(data).length === 0) { return <Loader color="#acff24" />; }

    return (
      <Wrapper> 
        <Navbar logoutParent={this.onLogout} />
        <Content>
          <ContentRow className="single-col">
            <h1>Hi, <span>{data.name.split(' ')[0]}</span></h1>
          </ContentRow>
          <ContentRow>
            <ContentCol>
              <SummaryInfo data={data} />
              <CoursePicker
                data={data}
                selectedCourse={selectedCourse}
                onSelectCourse={this.onSelectCourse}
                completedLessons={completedLessons}
              />
            </ContentCol>
            <ContentCol>
              <PerformanceGraph
                data={data}
                selectedCourse={selectedCourse}
                completedLessons={completedLessons}
              />
            </ContentCol>
          </ContentRow>
          <ContentRow>
            <ContentCol>
              <LessonSelector
                {...this.props}
                data={data}
                selectedCourse={selectedCourse}
                completedLessons={completedLessons}
              />
            </ContentCol>
            <ContentCol>
              <CourseTracker
                data={data}
                selectedCourse={selectedCourse}
                completedLessons={completedLessons}
              />
            </ContentCol>
          </ContentRow>
        </Content>
      </Wrapper>
    );
  }
}

export default withServices(DataCentre);



// WEBPACK FOOTER //
// ./src/pages/Students/DataCentre/DataCentre.tsx